import { render } from "./MenuNav.vue?vue&type=template&id=4bf9fa90&scoped=true"
import script from "./MenuNav.vue?vue&type=script&lang=js"
export * from "./MenuNav.vue?vue&type=script&lang=js"

import "./MenuNav.vue?vue&type=style&index=0&id=4bf9fa90&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bf9fa90"]])

export default __exports__